// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserComponents_Card = require("./BrowserComponents_Card.bs.js");
var BrowserComponents_Input = require("./BrowserComponents_Input.bs.js");
var BrowserComponents_Button = require("./BrowserComponents_Button.bs.js");
var BrowserComponents_Textarea = require("./BrowserComponents_Textarea.bs.js");

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.table),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
        tl: {
          hd: BrowserStyle.textAlign("left"),
          tl: /* [] */0
        }
      }
    });

var wrapper = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
      tl: {
        hd: BrowserStyle.marginTop(BrowserStyle.rem(1.0)),
        tl: {
          hd: BrowserStyle.padding(BrowserStyle.zero),
          tl: /* [] */0
        }
      }
    });

function row(isOdd) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.display(BrowserStyle.tableRow),
              tl: {
                hd: BrowserStyle.backgroundColor({
                      TAG: /* White */7,
                      _0: isOdd ? /* Medium */1 : /* Light */2
                    }),
                tl: /* [] */0
              }
            });
}

var tableTitle = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Large */4, undefined)({
          hd: BrowserStyle.display(BrowserStyle.tableCell),
          tl: {
            hd: BrowserStyle.width(BrowserStyle.pct(42.0)),
            tl: {
              hd: BrowserStyle.padding(BrowserStyle.rem(1.0)),
              tl: {
                hd: BrowserStyle.paddingLeft(BrowserStyle.rem(2.0)),
                tl: {
                  hd: BrowserStyle.width(BrowserStyle.rem(15.0)),
                  tl: {
                    hd: BrowserStyle.mobileMedia({
                          hd: BrowserStyle.paddingLeft(BrowserStyle.rem(1.0)),
                          tl: /* [] */0
                        }),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }));

function arg(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* Large */4, /* Bold */2);
}

var tableContent = Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), {
          hd: BrowserStyle.display(BrowserStyle.tableCell),
          tl: {
            hd: BrowserStyle.width(BrowserStyle.pct(58.0)),
            tl: {
              hd: BrowserStyle.padding(BrowserStyle.rem(1.0)),
              tl: {
                hd: BrowserStyle.whiteSpace("preWrap"),
                tl: /* [] */0
              }
            }
          }
        }));

function arg$1(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* Large */4, /* Bold */2);
}

var editContent = Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined, undefined), {
          hd: BrowserStyle.display(BrowserStyle.tableCell),
          tl: {
            hd: BrowserStyle.width(BrowserStyle.pct(44.0)),
            tl: {
              hd: BrowserStyle.padding(BrowserStyle.rem(1.0)),
              tl: {
                hd: BrowserStyle.whiteSpace("preWrap"),
                tl: {
                  hd: BrowserStyle.wordBreak("breakAll"),
                  tl: /* [] */0
                }
              }
            }
          }
        }));

function editInput(isOdd, inputHeight, extraContent) {
  var arg = function (param, param$1) {
    return BrowserStyle.withFont(param, param$1, /* Large */4, /* Bold */2);
  };
  return Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), {
                  hd: BrowserStyle.width(Relude_Option.isSome(extraContent) ? BrowserStyle.pct(50.0) : BrowserStyle.pct(100.0)),
                  tl: {
                    hd: BrowserStyle.padding("zero"),
                    tl: {
                      hd: BrowserStyle.height(inputHeight),
                      tl: {
                        hd: BrowserStyle.minHeight(BrowserStyle.rem(1.25)),
                        tl: {
                          hd: BrowserStyle.backgroundColor({
                                TAG: /* White */7,
                                _0: isOdd ? /* Medium */1 : /* Light */2
                              }),
                          tl: {
                            hd: BrowserStyle.border("zero", "none", {
                                  TAG: /* White */7,
                                  _0: /* Light */2
                                }),
                            tl: {
                              hd: BrowserStyle.resize("none"),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }));
}

var editIcon = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.paddingTop(BrowserStyle.rem(1.25)),
      tl: /* [] */0
    });

var confirmIcon = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.paddingTop(BrowserStyle.rem(1.25)),
      tl: /* [] */0
    });

var contentText = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.minHeight(BrowserStyle.rem(1.0)),
      tl: {
        hd: BrowserStyle.wordBreak("breakAll"),
        tl: /* [] */0
      }
    });

var Styles = {
  container: container,
  wrapper: wrapper,
  row: row,
  tableTitle: tableTitle,
  tableContent: tableContent,
  editContent: editContent,
  editInput: editInput,
  editIcon: editIcon,
  confirmIcon: confirmIcon,
  contentText: contentText
};

function BrowserComponents_InfoCard(Props) {
  var info = Props.info;
  var testId = Props.testId;
  var tmp = {
    children: React.createElement("div", {
          className: container
        }, Relude_Array.mapWithIndex((function (param, i) {
                var content = param.content;
                if (!Relude_String.isNonWhitespace(content)) {
                  return null;
                }
                var title = param.title;
                return React.createElement("div", {
                            key: title + content,
                            className: row(i % 2 === 1)
                          }, React.createElement("div", {
                                className: tableTitle
                              }, React.createElement(ReactUtils.S.make, {
                                    children: title
                                  })), React.createElement("div", {
                                className: tableContent
                              }, React.createElement(ReactUtils.S.make, {
                                    children: content
                                  })));
              }), info))
  };
  if (testId !== undefined) {
    tmp.id = Caml_option.valFromOption(testId);
  }
  return React.createElement(BrowserComponents_Card.make, {
              className: wrapper,
              children: React.createElement(ReactUtils.WithTestId.make, tmp)
            });
}

function BrowserComponents_InfoCard$Editable$EditableItem(Props) {
  var param = Props.info;
  var isOdd = Props.isOdd;
  var title = param.title;
  var onChange = param.onChange;
  var onBlur = param.onBlur;
  var extraContent = param.extraContent;
  var content = param.content;
  var match = ReactIO.useState(function (param) {
        return Css.rem(1.0);
      });
  var setInputHeight = match[1];
  var inputHeight = match[0];
  var match$1 = ReactIO.useDomRef(undefined);
  var inputDomRef = match$1[0];
  var match$2 = ReactIO.useState(function (param) {
        return false;
      });
  var setIsEditing = match$2[1];
  var setIsEditing$1 = function (isEditing) {
    return Relude_IO.flatMap((function (param) {
                  return Curry._1(setIsEditing, isEditing);
                }), Relude_IO.flatMap((function (param) {
                      return Relude_Globals.$great$great((function (param) {
                                    return Relude_Option.fold(inputHeight, (function (iRef) {
                                                  return Css.px(Relude_Float.roundAsInt(iRef.getBoundingClientRect().height));
                                                }), param);
                                  }), setInputHeight, param);
                    }), inputDomRef));
  };
  if (!match$2[0]) {
    return React.createElement("div", {
                key: title + content,
                className: row(isOdd)
              }, React.createElement("div", {
                    className: tableTitle
                  }, React.createElement(ReactUtils.S.make, {
                        children: title
                      })), React.createElement("div", {
                    className: editContent
                  }, React.createElement("span", {
                        ref: match$1[1],
                        className: contentText
                      }, React.createElement(ReactUtils.S.make, {
                            children: Relude_Option.getOrElse(content, param.displayContent)
                          }), Relude_Option.fold(null, (function (extraContent) {
                              return React.createElement(ReactUtils.S.make, {
                                          children: " " + extraContent
                                        });
                            }), extraContent))), React.createElement(BrowserComponents_Button.Icon.make, {
                    className: editIcon,
                    icon: {
                      TAG: /* Small */1,
                      _0: {
                        TAG: /* Shift */6,
                        _0: /* PencilEdit */16
                      }
                    },
                    iconColor: {
                      TAG: /* Teal */6,
                      _0: /* Medium */2
                    },
                    onClick: (function (param) {
                        return Relude_Globals.$great$great((function (param) {
                                      return Relude_Globals.$$const(true, param);
                                    }), setIsEditing$1, param);
                      }),
                    testId: Relude_String.removeEach(" ", "edit" + title)
                  }));
  }
  var tmp;
  switch (param.inputType) {
    case /* NumberFloat */0 :
        tmp = React.createElement("div", undefined, React.createElement(BrowserComponents_Input.BaseStatefulStyleType.make, {
                  autoFocus: true,
                  className: editInput(isOdd, inputHeight, extraContent),
                  onFocus: (function (param) {
                      return param.select;
                    }),
                  value: {
                    TAG: /* NumberFloat */4,
                    _0: {
                      clamp: undefined,
                      input: {
                        onChange: onChange,
                        value: content
                      }
                    }
                  }
                }), Relude_Option.fold(null, (function (extraContent) {
                    return React.createElement(ReactUtils.S.make, {
                                children: " " + extraContent
                              });
                  }), extraContent));
        break;
    case /* NumberInt */1 :
        tmp = React.createElement("div", undefined, React.createElement(BrowserComponents_Input.BaseStatefulStyleType.make, {
                  autoFocus: true,
                  className: editInput(isOdd, inputHeight, extraContent),
                  onFocus: (function (param) {
                      return param.select;
                    }),
                  value: {
                    TAG: /* NumberInt */5,
                    _0: {
                      clamp: undefined,
                      input: {
                        onChange: onChange,
                        value: content
                      }
                    }
                  }
                }), Relude_Option.fold(null, (function (extraContent) {
                    return React.createElement(ReactUtils.S.make, {
                                children: " " + extraContent
                              });
                  }), extraContent));
        break;
    case /* Text */2 :
        tmp = React.createElement(BrowserComponents_Textarea.make, {
              autoFocus: true,
              className: editInput(isOdd, inputHeight, extraContent),
              onChange: onChange,
              value: content
            });
        break;
    
  }
  var partial_arg = Relude_IO.flatMap((function (param) {
          return onBlur;
        }), setIsEditing$1(false));
  return React.createElement("div", {
              key: title,
              className: row(isOdd)
            }, React.createElement("div", {
                  className: tableTitle
                }, React.createElement(ReactUtils.S.make, {
                      children: title
                    })), React.createElement("div", {
                  className: editContent
                }, React.createElement(ReactUtils.WithTestId.make, {
                      id: Relude_String.removeEach(" ", "input" + title),
                      children: tmp
                    })), React.createElement(BrowserComponents_Button.Icon.make, {
                  className: confirmIcon,
                  icon: {
                    TAG: /* Small */1,
                    _0: {
                      TAG: /* Status */8,
                      _0: /* CircleChecked */4
                    }
                  },
                  iconColor: {
                    TAG: /* Teal */6,
                    _0: /* Medium */2
                  },
                  onClick: (function (param) {
                      return Relude_Globals.$$const(partial_arg, param);
                    }),
                  testId: Relude_String.removeEach(" ", "confirm" + title)
                }));
}

var EditableItem = {
  make: BrowserComponents_InfoCard$Editable$EditableItem
};

function BrowserComponents_InfoCard$Editable(Props) {
  var info = Props.info;
  return React.createElement(BrowserComponents_Card.make, {
              className: wrapper,
              children: React.createElement("div", {
                    className: container
                  }, Relude_Array.mapWithIndex((function (info, i) {
                          return React.createElement(React.Fragment, {
                                      children: React.createElement(BrowserComponents_InfoCard$Editable$EditableItem, {
                                            info: info,
                                            isOdd: i % 2 === 1
                                          }),
                                      key: Relude_Int.toString(i)
                                    });
                        }), info))
            });
}

var Editable = {
  EditableItem: EditableItem,
  make: BrowserComponents_InfoCard$Editable
};

var Icon;

var make = BrowserComponents_InfoCard;

exports.Icon = Icon;
exports.Styles = Styles;
exports.make = make;
exports.Editable = Editable;
/* container Not a pure module */
